import Box from "@cloudscape-design/components/box"
import Button from "@cloudscape-design/components/button"
import Popover from "@cloudscape-design/components/popover"
import SpaceBetween from "@cloudscape-design/components/space-between"

import type { CapabilitySet } from "@/services/capabilitySetsApi"

interface CapabilitySetSummaryProps {
  /**
   * The capability set's id, as the grant names it.
   */
  name: string
  /**
   * Undefined when the grant names a set the deployment no longer defines.
   */
  set: CapabilitySet | undefined
}

/**
 * Show a capability set's name as a link that opens its id and capabilities.
 */
export default function CapabilitySetSummary({ name, set }: CapabilitySetSummaryProps) {
  if (!set) {
    return (
      <SpaceBetween size="xxxs">
        <Box variant="code">{name}</Box>
        <Box fontSize="body-s" color="text-status-warning">
          Not configured in this deployment. This grant gives no access.
        </Box>
      </SpaceBetween>
    )
  }
  return (
    <Popover
      triggerType="custom"
      size="medium"
      header={set.display_name}
      content={
        <SpaceBetween size="xs">
          <Box variant="code" fontSize="body-s">
            {name}
          </Box>
          <Box fontSize="body-s">
            {`Includes: ${set.capabilities.map((c) => c.friendly_name).join(" · ")}`}
          </Box>
        </SpaceBetween>
      }
    >
      <Button variant="inline-link">{set.display_name}</Button>
    </Popover>
  )
}
